import { openGamePopup } from './game/popup'

let screenWidth = window.innerWidth
let screenHeight = window.innerHeight
if (screenWidth > 1920) {
  let fontCoef = screenWidth / 1440
  let maxFontCoef = screenWidth / 1920
  let fontSize = Math.floor(16 * fontCoef)
  let maxFontSize = Math.floor(16 * maxFontCoef)
  fontSize = fontSize > maxFontSize ? maxFontSize : fontSize

  $('html').css('font-size', fontSize + 'px')
}


if (screenWidth > 1920) {

  let toLeft = (screenWidth - 1920) / 2

  $('header').css('left', toLeft + 'px')

}

$(window).on('load', function (e){
  $('body').removeClass('is-loading')

  if(location.hash && location.hash.length > 1) {
    let hash = location.hash.substring(1)
    if(hash.length > 0 && hash === 'nelaimes-rats') {
      openGamePopup()
    }
  } else {
    let uri = window.location.toString();

    let showWheel = uri.includes("balva=");
    if(showWheel) {
      openGamePopup()
      history.replaceState({}, document.title, '/');
    }

  }

})

